var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00019 6.50019C5.86858 6.50095 5.73812 6.47572 5.61628 6.42596C5.49444 6.37619 5.38363 6.30287 5.29019 6.21019L1.29019 2.21019C1.19695 2.11695 1.12299 2.00626 1.07253 1.88443C1.02207 1.76261 0.996094 1.63204 0.996094 1.50019C0.996094 1.36833 1.02207 1.23776 1.07253 1.11594C1.12299 0.994113 1.19695 0.883424 1.29019 0.790185C1.38342 0.696946 1.49411 0.622985 1.61594 0.572525C1.73776 0.522065 1.86833 0.496094 2.00019 0.496094C2.13204 0.496094 2.26261 0.522065 2.38444 0.572525C2.50626 0.622985 2.61695 0.696946 2.71019 0.790185L6.00019 4.10019L9.30019 0.920185C9.39218 0.817895 9.50428 0.735687 9.6295 0.6787C9.75471 0.621714 9.89033 0.591177 10.0279 0.588998C10.1654 0.586819 10.302 0.613044 10.4289 0.666035C10.5559 0.719026 10.6705 0.797643 10.7657 0.896967C10.8609 0.996291 10.9346 1.11419 10.9821 1.24328C11.0297 1.37238 11.0501 1.50989 11.042 1.64723C11.034 1.78456 10.9977 1.91877 10.9355 2.04144C10.8732 2.16412 10.7863 2.27263 10.6802 2.36018L6.68019 6.22019C6.49731 6.3965 6.25419 6.49661 6.00019 6.50019Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.7eaea5c1e9dc375072c8a86f49a08f32.svg";
export { ForwardRef as ReactComponent };